import { Input, Output, Directive, HostListener, EventEmitter, Renderer, Renderer2, ElementRef, AfterViewInit, forwardRef, Attribute} from '@angular/core';
import { NgModel, Validator, Validators, AbstractControl, NG_VALIDATORS, FormControl } from '@angular/forms';
import { CommonService } from '../common.service';

@Directive({
  selector: '[preceedingSpaceIgnore]',
  providers: [NgModel],
  host: {
    '(keydown.space)': 'onInputChange($event)'
  }
})
export class PreceedingSpaceIgnore {
  @Input() ngModel;
  @Output() ngModelChange = new EventEmitter();

  ngOnInit() {
    //    this.ngModelChange.emit(this.ngModel);
  }

  constructor(private model: NgModel) {
    console.log(model)
  }

  onInputChange(event) {
    if (!event.target.value)
      event.preventDefault();
  }
}

@Directive({
  selector: '[percentageSign]',
  providers: [NgModel],
})
export class PercentageSign {
  ngAfterViewInit() {
    var parent = this._el.nativeElement.parentNode;
    var pElement = this._renderer.createElement(parent, "span", null);
    this._renderer.setElementClass(pElement, "percentage", true)
    this._renderer.createText(pElement, "%", null)
  }
  constructor(private _renderer: Renderer, private _el: ElementRef) {
  }
};

/*@Directive({
 selector: '[percentageSign]',
 providers: [NgModel],
 })
 export class PercentageSign {

 constructor(private _render:Renderer, private _renderer:Renderer2, private _el: ElementRef) {
 }

 ngAfterViewInit() {

 var parent = this._el.nativeElement.parentNode;
 var currentElement = this._el.nativeElement;
 this._renderer.removeChild(parent, this._el.nativeElement);

 //parent//
 var divElement = this._renderer.createElement("div", null);
 this._renderer.addClass(divElement, "input-group");


 this._renderer.appendChild(divElement, this._el.nativeElement)


 var spanElement = this._renderer.createElement("span", null);
 this._renderer.addClass(spanElement, "input-group-addon");
 this._render.createText(spanElement, "%", null);
 this._renderer.appendChild(divElement, spanElement);

 this._renderer.appendChild(parent, divElement);

 console.log(parent);

 }
 };*/



@Directive({
  selector: '[cmaxlength][formControlName],[cmaxlength][formControl],[cmaxlength][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CMaxlength), multi: true }
  ]
})
export class CMaxlength implements Validator {
  constructor( @Attribute('cmaxlength') public maxLength: string, private _el: ElementRef) { }

  validate(c: AbstractControl): { [key: string]: any } {
    let v = this._el.nativeElement.value;
    let e = (this.maxLength);
    if (e && (v || "").length > e) {
      return {
        maxlength: {
          actualLength: v.length,
          requiredLength: e
        }
      }
    }
    return null;
  }
};

@Directive({
  selector: '[custompattern][formControlName],[custompattern][formControl],[custompattern][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CustomPattern), multi: true }
  ]
})
export class CustomPattern implements Validator {
  constructor( @Attribute('custompattern') public pattern: RegExp, private _el: ElementRef) { }

  validate(c: AbstractControl): { [key: string]: any } {
    let v = this._el.nativeElement.value;
    let e = new RegExp(this.pattern);
    let res = e.test(v);
    if (!res && v) {
      let espace = new RegExp(" ");
      return {
        custompattern: {
          invalidSpace: espace.test(v),
          otherChar: espace.test(v) ? false : true
        }
      }
    }
    return null;
  }
};


@Directive({
    selector: '[keyboard-disabled]',
    providers: [NgModel],
    host: {
      '(keydown)': 'onInputChange($event)'
    }
  })
  export class KeyboardDisabled {
    @Input() ngModel;
    @Output() ngModelChange = new EventEmitter();

    ngOnInit() {
//      this.ngModelChange.emit(this.ngModel);
    }

    constructor(private model:NgModel) {
    }

    onInputChange(event) {
      event.preventDefault();
      return false;
    }
  };
@Directive({
    selector: '[dot-disabled]',
    providers: [NgModel],
    host: {
      '(keydown)': 'onInputChange($event)'
    }
  })
  export class DotDisabled {
    @Input() ngModel;
    @Output() ngModelChange = new EventEmitter();

    ngOnInit() {
//      this.ngModelChange.emit(this.ngModel);
    }

    constructor(private model:NgModel) {
      console.log(model)
    }

    onInputChange(event) {
        var key = event.charCode ? event.charCode : event.keyCode;  
        if (key == 46 || key == 190)
        {
            event.preventDefault();
            return false;
        }    
    }
  };


  @Directive({
      selector: '[check-max-value][formControlName],[check-max-value][formControl],[check-max-value][ngModel]',
      providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CheckMaxValue), multi: true }
      ]
    })
    export class CheckMaxValue implements Validator {
      constructor( @Attribute('check-max-value') public value: string, private _el: ElementRef) { }

      validate(c: AbstractControl): { [key: string]: any } {
        let v = +this._el.nativeElement.value;
        let e = +(this.value);
        if (v>e) {
          return {
            maxValue: {
              actualValue: v,
              requiredMaxValue: e
            }
          }
        }
        return null;
      }
    };
    
    
    @Directive({
        selector: '[number-validations][formControlName],[number-validations][formControl],[number-validations][ngModel]',
        providers: [
          { provide: NG_VALIDATORS, useExisting: forwardRef(() => NumberValidations), multi: true }
        ],
        host: {
        '(keydown)': 'onInputChange($event)'
      }
      })
      export class NumberValidations implements Validator {
        @Input('min') min;
        @Input('max') max;
        @Input('step') step;
        constructor( @Attribute('number-validations') public value: string, private _el: ElementRef, private common: CommonService) { 
        }
        onInputChange(event) {
            var key = event.charCode ? event.charCode : event.keyCode;  
            if (key == 69)
            {
                event.preventDefault();
                return false;
            }    
        }

        validate(c: AbstractControl): { [key: string]: any } {
            
            let val: any = c.value;

//      if(isPresent(Validators.required(c))) {
//          return null;
//              }
            if(val != null && val != '' && (isNaN(val) &&  !this.common.patterns.numberDecimalWithNegative.test((val || "").toString()))) {
                return {"number": true};
            }
            
      if(val != null && val != '' && this.step !=null){
          if(this.step % 1 != 0){
              var spl = (this.step + "").split(".");
              if(spl.length>1){
                  var decimalLength = spl[1].length;
                  var reg = this.common.patterns.numberDecimalWithNegativeString.replace(/endDecimal/gi, decimalLength.toString());
                  var regex = new RegExp(reg, "i");
                  if(!regex.test((val || "").toString())){
                      return {"step": true};
                  }
              }
          } else {
              if((val + "").split(".").length>1){
                  return {"step": true};
              }
          }
      }
      if(val !=null && val != '' && !isNaN(this.min) && val < this.min) {
        return  {"min": true};
      } 
      if(val !=null && val != '' && !isNaN(this.max) && val > this.max) {
        return {"max": true};
      } else {
          return null;
      }            
        }
      };







// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/directives/custom.directive.ts